export class Result {
    strP: ResP;
    str: Res;
    snpP: ResP;
    snp: Res;
    tests: GeneTest[];
}

export class ResP {
    result: string;
    status : string;
    statusReason : string;
    fatherParentAgeResult:ParentMatchResult;
    motherParentAgeResult:ParentMatchResult;
    createdDate: string;
}
export class ParentMatchResult{
    pairs : number;
    misMatch : number;
}

export class Res {
    markers: Marker[];
    createdDate: string;
}

export class Marker {
    markerName: string;
    value: string;
    panel: string;
}

export class GeneTest {
    code: string;
    result: string;
}